import { DOCUMENT } from '@angular/common';
import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';

import { AddCoachMeetingDialogComponent } from 'dialog/add-coach-meeting-dialog/add-coach-meeting-dialog.component';
import { environment } from 'environments/environment';
import { CoacheeProfileController } from 'presentation/page/profile/coachee-profile/coachee-profile.controller';
import { IUser } from 'user/user';

@Component({
	selector: 'spr-coachee-profile-information-details',
	templateUrl: './coachee-profile-information-details.component.html',
})
export class CoacheeProfileInformationDetailsComponent {
	public picturePlaceholder = environment.profilePlaceholder;

	@Input() public coachee: IUser;
	@Output() public openPlan = new EventEmitter<string>();
	@Output() public openChat = new EventEmitter<string>();

	constructor(
		private _dialogService: DialogService,
		private _translateService: TranslateService,
		private _coacheeProfileController: CoacheeProfileController,
		@Inject(DOCUMENT) private _document: Document
	) {}

	public onAddMeetingClick(coachee: IUser) {
		this._dialogService
			.open(AddCoachMeetingDialogComponent, {
				header: this._translateService.instant(
					'presentation.app.common.dialog.addCoachMeeting.title',
					{ name: coachee.name }
				),
				data: { coacheeId: coachee.id },
				style: { maxWidth: '80vw' },
				dismissableMask: true,
				width: '400px',
				modal: true,
			})
			.onClose.subscribe(() =>
				this._coacheeProfileController.triggerMeetingsReload()
			);
	}

	public onSendEmailClick(email: string): void {
		this._document.location.href = `mailto:${email}`;
	}
}
